/**
 * File: useNewMenuController.ts
 * Path: apps/admin/src/features/today/hooks/useNewMenuController.ts
 * Description: The Today page's "New" button: what it offers (lead, find leads, quote, contract) and where each goes.
 */

import { useNavigate } from "react-router-dom";
import { ADMIN_PATHS } from "@idk/config";

export const useNewMenuController = (onNewLead: () => void) => {
  const navigate = useNavigate();
  const items: { label: string; hint: string; run: () => void }[] = [
    { label: "New lead", hint: "Someone you could work with", run: onNewLead },
    { label: "Find leads", hint: "Search Google Maps for businesses", run: () => navigate(ADMIN_PATHS.leads.find) },
    { label: "New quote", hint: "Price a job for a lead or client", run: () => navigate(ADMIN_PATHS.quotes.new) },
    { label: "New contract", hint: "An agreement to send and sign", run: () => navigate(ADMIN_PATHS.contracts.new) },
  ];
  return { items };
};
